export class ModalButton {
    name: string;
    isPrimary: boolean = true;
    onClick: () => any;

    constructor(name: string, onClickCallback: () => any, isPrimary = true) {
        this.name = name;
        this.onClick = onClickCallback;
        this.isPrimary = isPrimary;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/modal/modal-button.ts